import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Wrapper, Label, TopRightBottomLeft } from './Panel'
import { AppState } from '../../../../../stateManager/store'
import { data } from './data'
import { updateGridStyles } from '../../../../../stateManager/store/formCreation_v2/actions'
import { GetFontFamilyList } from './layout-components/helpers/getFontFamilyList'
import { Checkbox, Dropdown } from './layout-components/helpers/constants'
import { ColorPicker, ColorPickerMenu } from './ColorPicker'
import { ReactComponent as SyncBtn } from "../../../../../assets/svg/solobuilder/SyncOne.svg";
import { onSetBgdMenuVisibility, onSetBorderVisibility, onSetFontStylesVisibility, onSetTextEditorVisibility, onsetClrPicContext, onsetDropShadowVisibility, onSetErrorFontStylesVisibility } from '../../../../../stateManager/store/common/action'
import { useToast } from '../../../../../helpers/commonFunction'
import {ApplyBackgroundImage, BackgroundImageMenu} from './BackgroundImageMenu'
import useSyncStyles  from '../helpers/useSyncStyles';
import SyncStyle from "../helpers/SyncStyle";

const { cols, rows, 
  layouts, 
  flexDirection, 
  flexAlignItems,
  flexJustifyContent,
  gridAutoRows
} = data

export const GridLayout = (props: any) => {
const { syncStyles } = useSyncStyles();
  const dispatch = useDispatch()
  const { gridStyles, deviceType, isGridSelected } = useSelector((state: AppState) => state.formJson)
  const { colorPickerContext, backgroundMenuVisibility } = useSelector((state: any) => state.common);
  const styles = gridStyles[deviceType]
  const backgroundColor = styles.backgroundColor || ""
  const canvasFontFamily = gridStyles.common?.canvasFontFamily || 'Arial'
  const isCoreV3 = useSelector((state: any) => state.formJson?.isCoreV3);

  const setColorPickerVisibility = (visibility: boolean) => {
    dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: visibility }))
  };

  const handleChange = (path: string, value: string | boolean) => {
    dispatch(updateGridStyles({
      path: `$deviceType.${path}`,
      value,
    }))
  }

  const optionList=GetFontFamilyList()
  return (
    <>
      {isCoreV3 &&
        <>
          <SyncStyle
            syncTo= "CANVAS"
            deviceType = {deviceType}
            handleSync = {syncStyles}
          />
          <hr style={{ width: '100%', margin: '10px auto' }} />
        </>
      }
    <div>
      {(isGridSelected && isCoreV3) && <Wrapper>
        <Label id="layoutType" label="Layout Type" />
        <Dropdown
          disabled={!props.isCheckedIn}
          options={layouts.map(el => ({ name: el.label }))}
          selected={{ name: styles.layout }}
          onChange={({ name }) => {
            handleChange('layout', name)
          }}
        />
      </Wrapper>}

      {/* if grid is selected */}
      {( (isGridSelected && isCoreV3 && styles.layout === "Grid")
      || (isGridSelected && !isCoreV3)) && 
      <>
        {/* Grid columns */}
        <Wrapper>
          <Label id="gridCols" label="Grid cols" />
          <Dropdown
            disabled={!props.isCheckedIn}
            options={cols.map(el => ({ name: el.label }))}
            selected={{ name: styles.gridCols }}
            onChange={({ name }) => {
              handleChange('gridCols', name)
            }}
          />
        </Wrapper>

        {/* Grid rows */}
        <Wrapper>
          <Label id="gridRows" label="Grid rows" />
          <Dropdown
            disabled={!props.isCheckedIn}
            options={rows.map((el: any) => ({ name: el.label }))}
            selected={{ name: styles.gridRows }}
            onChange={({ name }) => {
              handleChange('gridRows', name)
            }}
          />
        </Wrapper>

        {/* Grid auto rows */}
        <Wrapper>
          <Label id="gridAutoRows" label="Grid auto rows" />
          <Dropdown
            disabled={!props.isCheckedIn}
            options={gridAutoRows.map((el: any) => ({ name: el.label }))}
            selected={{ name: gridAutoRows.find(item => item.value === styles.gridAutoRows)?.label || "" }}
            onChange={({ name }) => {
              const value = gridAutoRows.find(item => item.label === name)?.value || ""
              handleChange('gridAutoRows', value)
            }}
          />
          </Wrapper>
          <>
            <Wrapper>
              <Label id="gridAutoRows" label="Gap" />
              <input
                disabled={!props.isCheckedIn}
                type="number"
                id="gap"
                value={styles.gap}
                className="panel-input focus:ring-blue-500 focus:border-blue-500 block p-1.5"
                onChange={e => {
                  handleChange('gap', e.target.value)
                }}
              />
            </Wrapper>
          </>
      </>}

      {/* if flex is selected */}
      {(isGridSelected && styles.layout === "Flex" && isCoreV3 === true) && 
      <>
        <Wrapper>
          <Label id="flexDirection" label="Flex Direction" />
          <Dropdown
            disabled={!props.isCheckedIn}
            options={flexDirection.map((el: any) => ({ name: el.label }))}
            selected={{ name: styles.flexDirection }}
            onChange={({ name }) => {
              handleChange('flexDirection', name)
            }}
          />
        </Wrapper>
        <Checkbox
          disabled={!props.isCheckedIn}
          key="flexWrap"
          id="flexWrap"
          value={styles.flexWrap}
          label="Wrap on overflow"
          onChange={(_, value) => {
            handleChange('flexWrap', value)
          }}
        />
        <Wrapper>
          <Label id="flexAlignItems" label="Align Items" />
          <Dropdown
            disabled={!props.isCheckedIn}
            options={flexAlignItems.map((el: any) => ({ name: el.label, value: el.value }))}
            selected={{ name: styles.flexAlignItems }}
            onChange={({ name }) => {
              handleChange('flexAlignItems', name)
            }}
          />
        </Wrapper>
        <Wrapper>
          <Label id="flexJustifyContent" label="Justify Content" />
          <Dropdown
            disabled={!props.isCheckedIn}
            options={flexJustifyContent.map((el: any) => ({ name: el.label, value: el.value }))}
            selected={{ name: styles.flexJustifyContent }}
            onChange={({ name }) => {
              handleChange('flexJustifyContent', name)
            }}
          />
        </Wrapper>
      </>}

      {!isGridSelected && <div className="grid grid-cols-3 gap-4 mx-2 mt-3">
        <label
          htmlFor="gap"
          className="block mt-2 py-1 px-2 text-lg font-semibold text-gray-900 dark:text-gray-300"
        >
          Gap
        </label>
        <input
          disabled={!props.isCheckedIn}
          type="number"
          id="gap"
          value={styles.gap}
          className="panel-input focus:ring-blue-500 focus:border-blue-500 block p-2.5 px-4"
          onChange={e => {
            handleChange('gap', e.target.value)
          }}
        />
      </div>}
      <TopRightBottomLeft
        disabled={!props.isCheckedIn}
        id="padding"
        label="Padding" 
        value={{
          overall: styles.padding,
          top: styles.paddingTop,
          right: styles.paddingRight,
          bottom: styles.paddingBottom,
          left: styles.paddingLeft,
        }}
        onChange={(key: string, value: string) => {
          handleChange(key, value)
        }}
      />
      <ColorPicker
        pickerkey={"canvasBackground"}
        label={"Background Color"}
        value={backgroundColor}
        open={() => {
          dispatch(onsetClrPicContext({
            value: backgroundColor,
            placeholder: "#FFFFFF",
            where: "$deviceType.backgroundColor",
            visibility: true,
          }))
          dispatch(onsetDropShadowVisibility(false))
          dispatch(onSetBorderVisibility(false))
          dispatch(onSetFontStylesVisibility(false))
          dispatch(onSetErrorFontStylesVisibility(false))
          dispatch(onSetTextEditorVisibility(false))
          dispatch(onSetBgdMenuVisibility(false))
        }}
        visibility={colorPickerContext?.visibility}
        close={()=>setColorPickerVisibility(false)}
        />
        <ApplyBackgroundImage
          from="canvas"
          open={() => {
            dispatch(onSetBgdMenuVisibility(true));
            setColorPickerVisibility(false);
          }} label={"Background Image"}
          menuVisibility={backgroundMenuVisibility}
        />
        {backgroundMenuVisibility ?
          (
            <BackgroundImageMenu
              from="GridLayout"
              type="canvas"
              where="$deviceType.canvasBackgroundImage"
              close={() => dispatch(onSetBgdMenuVisibility(false))}
              isCheckedIn={props.isCheckedIn}
            />
          ) : null
        }
      {colorPickerContext?.visibility ? (
        <ColorPickerMenu
          isCheckedIn={true}
          close={() => setColorPickerVisibility(false)}
          onChange={(where, value) => {
            handleChange("backgroundColor", value)}
          }
        />
      ) : null}
      {/* Removing font-family property from core-v3 on canvas level in favour of supporting font-family on component level */}
      {!isCoreV3 && <Wrapper key="fontFamily">
        <Label id="fontFamily" label="Font Family " />
        <Dropdown
        cursorStyle={!props.isCheckedIn ? "not-allowed" : "auto"}
        disabled={!props.isCheckedIn}
        options={
            optionList
        }
        type='fontFamily'
        selected={{ name: canvasFontFamily }}
        onChange={(option) => {
            const merggedArray = [...optionList?.customFonts, ...optionList?.systemFonts]
            const item = merggedArray.find((item:any) => item.name === option.name)
            if (item) {
              const value = item.name
              dispatch(updateGridStyles({
                path: `common.canvasFontFamily`,
                value,
              }))
            }
        }}
      />
      </Wrapper>}
    </div>
    </>
  )
}
